import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const DRPROXPRACTITIONER_URL = generateUrl()

const drProxPractitionerApiInstance = axios.create({
    baseURL: `${DRPROXPRACTITIONER_URL}/drprox`
})

drProxPractitionerApiInstance.interceptors.request.use(onRequestSuccess, undefined)
drProxPractitionerApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default drProxPractitionerApiInstance
